import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'seo';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_SEO_DATA = createActionName('RECEIVE_SEO_DATA');

export function receiveSeoData(data) {
  return {
    type: RECEIVE_SEO_DATA,
    payload: {
      ...data,
    },
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_SEO_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
